import React from 'react';
import popupImg from '../assets/popup-requisitos-becas.jpg';

export default function PopupRequisitos({ onClose }) {
  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={onClose} aria-label="Cerrar">
          &times;
        </button>
        <img
          src={popupImg}
          alt="Requisitos Becas Ciclo"
          className="popup-image"
        />
      </div>
    </div>
  );
}
